import { useBoolean } from "ahooks";
import { Fragment, memo, useCallback } from "react";
import { useDataRoomErrorReport } from "contexts";
import DataRoomErrorReportDialog from "./DataRoomErrorReportDialog";

interface DataRoomErrorReportButtonProps {
  error: string;
  details: string;
  onComplete?: () => void;
  renderTrigger: (openDialog: () => void) => React.ReactNode;
}

const DataRoomErrorReportButton = memo<DataRoomErrorReportButtonProps>(
  ({ error, details, onComplete, renderTrigger }) => {
    const contextValue = useDataRoomErrorReport();
    const [isDialogOpen, { setFalse: closeDialog, setTrue: openDialog }] =
      useBoolean(false);
    const handleFinish = useCallback(() => {
      onComplete?.();
      closeDialog();
    }, [closeDialog, onComplete]);
    return (
      <Fragment>
        {renderTrigger(openDialog)}
        <DataRoomErrorReportDialog
          details={details}
          error={error}
          onCancel={closeDialog}
          onFinish={handleFinish}
          open={isDialogOpen}
          {...contextValue}
        />
      </Fragment>
    );
  }
);

DataRoomErrorReportButton.displayName = "DataRoomErrorReportButton";

export default DataRoomErrorReportButton;
